import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const companyInformationStatistics = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '公司',
            dataIndex: 'company',
            key: 'company',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.company || [],
        },
        {
            title: '合同数量',
            dataIndex: 'numberOfContracts',
            key: 'numberOfContracts',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.numberOfContracts || [],
        },
        {
            title: '合同金额',
            dataIndex: 'contractAmount',
            key: 'contractAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.contractAmount || [],
        },
        {
            title: '预付款合同金额',
            dataIndex: 'preContractAmount',
            key: 'preContractAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.preContractAmount || [],
        },
        {
            title: '尾款金额',
            dataIndex: 'balancePaymentAmount',
            key: 'balancePaymentAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.balancePaymentAmount || [],
        },
        {
            title: '已开票金额',
            dataIndex: 'invoicedAmount',
            key: 'invoicedAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.invoicedAmount || [],
        },
        {
            title: '到款金额',
            dataIndex: 'paymentAmount',
            key: 'paymentAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.paymentAmount || [],
        },
        {
            title: '已收样未开票金额',
            dataIndex: 'sampleNoInvoiceAmount',
            key: 'sampleNoInvoiceAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.sampleNoInvoiceAmount || [],
        },
        {
            title: '已下机未开票金额',
            dataIndex: 'offBoardNoInvoiceAmount',
            key: 'offBoardNoInvoiceAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.offBoardNoInvoiceAmount || [],
        },
        {
            title: '已分析结束未开票金额',
            dataIndex: 'analysisOverNoInvoiceAmount',
            key: 'analysisOverNoInvoiceAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.analysisOverNoInvoiceAmount || [],
        },
        {
            title: '超期账款（发票超过6个月未到款）',
            dataIndex: 'overdueSixAccounts',
            key: 'overdueSixAccounts',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.overdueSixAccounts || [],
        },
        {
            title: '超期账款（发票超过3个月未到款）',
            dataIndex: 'overdueThreeAccounts',
            key: 'overdueThreeAccounts',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.overdueThreeAccounts || [],
        },
        {
            title: '预付款到款金额',
            dataIndex: 'prepayments',
            key: 'prepayments',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.prepayments || [],
        },
        {
            title: '预付款剩余金额',
            dataIndex: 'allPrepayments',
            key: 'allPrepayments',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.allPrepayments || [],
        },
        {
            title: '应收账款',
            dataIndex: 'accountsReceivable',
            key: 'accountsReceivable',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.accountsReceivable || [],
        },
        {
            title: '开票数量',
            dataIndex: 'numberOfInvoices',
            key: 'numberOfInvoices',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.numberOfInvoices || [],
        },
        {
            title: '退票数量',
            dataIndex: 'numberOfRefundedTickets',
            key: 'numberOfRefundedTickets',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.numberOfRefundedTickets || [],
        }
    ]
}
